import { InfoCard as InfoCardBase } from "@omni/components/components/General/InfoCard/infoCard";
import { InfoCardProps } from "@omni/types/components/props/infoCard.props";
import { cn } from "@omni/utils/styles";

const InfoCard = ({
    description,
    icon,
    iconAltText,
    link,
    linkLabel,
    title
}: InfoCardProps) => {
    return (
        <InfoCardBase className={cn("tw:rounded-2xl!")}>
            <InfoCardBase.Header>
                <InfoCardBase.Header.Title>{title}</InfoCardBase.Header.Title>
                {icon && (
                    <InfoCardBase.Header.Icon
                        src={icon}
                        alt={iconAltText || title}
                    />
                )}
            </InfoCardBase.Header>
            <InfoCardBase.Body>
                <InfoCardBase.Body.Content>
                    {description}
                </InfoCardBase.Body.Content>
                {link && linkLabel && (
                    <InfoCardBase.Body.Link href={link}>
                        {linkLabel}
                    </InfoCardBase.Body.Link>
                )}
            </InfoCardBase.Body>
        </InfoCardBase>
    );
};

export { InfoCard };
